import React from 'react'

function GpsTracking() {
  return (
    <div>GpsTracking</div>
  )
}

export default GpsTracking